import { createContext, useContext, useState, useCallback } from 'react';
import FeedbackModal from '@/components/feedback/FeedbackModal';

interface FeedbackContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const FeedbackContext = createContext<FeedbackContextValue | null>(null);

export function FeedbackProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <FeedbackContext.Provider value={{ isOpen, open, close }}>
      {children}
      <FeedbackModal isOpen={isOpen} onClose={close} />
    </FeedbackContext.Provider>
  );
}

export function useFeedback(): FeedbackContextValue {
  const ctx = useContext(FeedbackContext);
  if (!ctx) throw new Error('useFeedback must be used within FeedbackProvider');
  return ctx;
}
